






import { Component, Mixins } from "vue-property-decorator";
import { BrowserUtility, BrowserKinds } from "../../utilities";
import StandardPdfPrinter from "./pdfPrinters/StandardPdfPrinter.vue";
import ChromePdfPrinter from "./pdfPrinters/ChromePdfPrinter.vue";
import InternetExplorerPdfPrinter from "./pdfPrinters/InternetExplorerPdfPrinter.vue";
import AssistantPdfPrinter from "./pdfPrinters/AssistantPdfPrinter.vue";
import {
  ISourcePrintable,
  instanceOfISourcePrintable,
} from "./ISourcePrintable";
import {
  ISourcePrinterSpecifiable,
  instanceOfISourcePrinterSpecifiable
} from "./ISourcePrinterSpecifiable";

@Component({
  components: {
    Unknown: StandardPdfPrinter,
    InternetExplorer: InternetExplorerPdfPrinter,
    MicrosoftEdge: StandardPdfPrinter,
    ChromiumEdge: ChromePdfPrinter,
    GoogleChrome: ChromePdfPrinter,
    Safari: StandardPdfPrinter,
    MozillaFirefox: StandardPdfPrinter,
    Opera: StandardPdfPrinter,
    Assistant: AssistantPdfPrinter,
  }
})
export default class PdfPrinter extends Mixins() implements ISourcePrintable, ISourcePrinterSpecifiable {
  get key(): string {
    return this.isAssistantEnable
      ? "Assistant"
      : BrowserKinds[BrowserUtility.getBrowserKind()];
  }

  private get isAssistantEnable(): boolean {
    return this.$store.getters.configuration.behavior.localhost.isEnable
        || this.$store.getters.configuration.behavior.localhost.printer.isEnable;
  }

  printSource(source: string, copies?: number, shouldSelectPrinter?: boolean, shouldPrintWatermarkForcibly?: boolean, launchRequestKey?: string) {
    if (source === "") {
      return;
    }
    if (instanceOfISourcePrintable(this.$refs.printer)) {
      this.$refs.printer.printSource(source, copies, shouldSelectPrinter, shouldPrintWatermarkForcibly, launchRequestKey);
    }
  }

  printSourceTo(source: string, printerName: string, copies?: number, launchRequestKey?: string) {
    if (source === "") {
      return;
    }
    if (instanceOfISourcePrinterSpecifiable(this.$refs.printer)) {
      this.$refs.printer.printSourceTo(source, printerName, copies, launchRequestKey);
    }
  }
}
